/**
 * Placement Tolerances
 *
 * One tolerance for "does the design fit its print area", shared by the
 * carry-over rule (uniformRescale) and the QC validation (validate).
 */

/**
 * Relative tolerance (fraction of the print area edge) below which a design
 * poking out of its area still counts as fitting. Inclusive: an overflow of
 * exactly this fraction is treated as inside.
 *
 * 2 % covers the known rounding cases from the guided entry (a tall motif at
 * the maximum width overshooting the top edge by ~1 %), while a deliberate
 * overflow of 5 % or more is still recognised as intent.
 */
export const OVERFLOW_TOLERANCE_REL = 0.02;
